import type { FC } from 'react';

import { css } from '@styled-system/css';
import vipStoryIcon from './assets/vip-story-icon.svg';

export const VipOnlyBadge: FC = () => (
  <img
    src={vipStoryIcon}
    alt="VIP"
    width="14"
    height="14"
    className={css({
      position: 'relative',
      top: '-2px',
      marginRight: '5px',
    })}
  />
);
